// THIS FILE IS AUTO-GENERATED. DO NOT EDIT DIRECTLY.
// Generated by generate-enums.ts

import { z } from 'zod/v3';

export const OrganizationRoleSchema = z.enum([
  "OWNER",
  "ADMIN",
  "MEMBER",
  "VIEWER",
  "owner",
  "admin",
  "member"
]);
export type OrganizationRole = z.infer<typeof OrganizationRoleSchema>;

export const LanguageCodeSchema = z.enum([
  "EN",
  "ZH"
]);
export type LanguageCode = z.infer<typeof LanguageCodeSchema>;

export const ServiceAccountTypeSchema = z.enum([
  "COMPLIANCE_BOT",
  "INTEGRATION_BOT",
  "MONITORING_BOT",
  "COMPLIANCE_AGENT"
]);
export type ServiceAccountType = z.infer<typeof ServiceAccountTypeSchema>;

export const LabelColorSchema = z.enum([
  "GREY",
  "DARK_GREY",
  "PURPLE",
  "TEAL",
  "GREEN",
  "YELLOW",
  "ORANGE",
  "PINK",
  "RED"
]);
export type LabelColor = z.infer<typeof LabelColorSchema>;

export const DeploymentModeSchema = z.enum([
  "STATIC",
  "DYNAMIC"
]);
export type DeploymentMode = z.infer<typeof DeploymentModeSchema>;

export const RecordingPurposeSchema = z.enum([
  "EVIDENCE",
  "REMEDIATION"
]);
export type RecordingPurpose = z.infer<typeof RecordingPurposeSchema>;

export const TopicStatusSchema = z.enum([
  "Generating",
  "NotStarted",
  "InProgress",
  "Completed"
]);
export type TopicStatus = z.infer<typeof TopicStatusSchema>;

export const TopicTypeSchema = z.enum([
  "GUIDE",
  "SECTION",
  "GROUP",
  "CHANGELOG_SECTION",
  "CHANGELOG_INDEX",
  "CHANGELOG",
  "API_SECTION"
]);
export type TopicType = z.infer<typeof TopicTypeSchema>;

export const DocStatusSchema = z.enum([
  "Generating",
  "Pending",
  "Extracting",
  "Indexing",
  "Summarizing",
  "Completed",
  "Failed"
]);
export type DocStatus = z.infer<typeof DocStatusSchema>;

export const DocDifficultySchema = z.enum([
  "Beginner",
  "Intermediate",
  "Advanced"
]);
export type DocDifficulty = z.infer<typeof DocDifficultySchema>;

export const IconCategorySchema = z.enum([
  "EMOJI",
  "LUCIDE"
]);
export type IconCategory = z.infer<typeof IconCategorySchema>;

export const IconTypeSchema = z.enum([
  "REGULAR",
  "SOLID",
  "LIGHT",
  "THIN",
  "SHARP_SOLID",
  "DUOTONE",
  "BRANDS"
]);
export type IconType = z.infer<typeof IconTypeSchema>;

export const ExceptionKindSchema = z.enum([
  "FINDING",
  "SCOPE",
  "SCOPE_INCLUDE",
  "TEST"
]);
export type ExceptionKind = z.infer<typeof ExceptionKindSchema>;

export const ExceptionReasonSchema = z.enum([
  "AUTO_MANAGED",
  "STATIC_WEBSITE",
  "VENDOR_MANAGED",
  "DEV_SANDBOX",
  "ACCEPTED_RISK",
  "COMPENSATING_CONTROL",
  "OTHER",
  "OUT_OF_SCOPE_DEV",
  "OUT_OF_SCOPE_VENDOR",
  "OUT_OF_SCOPE_INTERNAL",
  "OUT_OF_SCOPE_DECOMMISSION"
]);
export type ExceptionReason = z.infer<typeof ExceptionReasonSchema>;

export const WorkspaceDataExportStatusSchema = z.enum([
  "QUEUED",
  "GENERATING",
  "READY",
  "READY_WITH_WARNINGS",
  "FAILED",
  "EXPIRED"
]);
export type WorkspaceDataExportStatus = z.infer<typeof WorkspaceDataExportStatusSchema>;

export const TaskResolutionOutcomeSchema = z.enum([
  "FULFILLED",
  "DENIED",
  "CANCELLED",
  "DUPLICATE",
  "NOT_ACTIONABLE"
]);
export type TaskResolutionOutcome = z.infer<typeof TaskResolutionOutcomeSchema>;

export const EvidenceCandidateEligibilitySchema = z.enum([
  "READY",
  "INCOMPLETE",
  "EXCLUDED"
]);
export type EvidenceCandidateEligibility = z.infer<typeof EvidenceCandidateEligibilitySchema>;

export const EvidenceBindingBasisSchema = z.enum([
  "RUN_CES",
  "CES_WORKFLOW",
  "TASK_CES",
  "ADDITIONAL_BINDING"
]);
export type EvidenceBindingBasis = z.infer<typeof EvidenceBindingBasisSchema>;

export const EmployeeStatusSchema = z.enum([
  "ACTIVE",
  "ON_LEAVE",
  "TERMINATED",
  "CONTRACTOR"
]);
export type EmployeeStatus = z.infer<typeof EmployeeStatusSchema>;

export const LifecycleStatusSchema = z.enum([
  "NONE",
  "ONBOARDING",
  "OFFBOARDING"
]);
export type LifecycleStatus = z.infer<typeof LifecycleStatusSchema>;

export const EmployeeSourceSchema = z.enum([
  "MANUAL",
  "CSV",
  "HRIS",
  "IDP"
]);
export type EmployeeSource = z.infer<typeof EmployeeSourceSchema>;

export const EmployeeTypeSchema = z.enum([
  "FULL_TIME",
  "PART_TIME",
  "CONTRACTOR",
  "INTERN",
  "TEMP"
]);
export type EmployeeType = z.infer<typeof EmployeeTypeSchema>;

export const ComplianceExclusionReasonSchema = z.enum([
  "SERVICE_ACCOUNT",
  "TEST_ACCOUNT",
  "SHARED_ACCOUNT",
  "EXTERNAL",
  "OTHER"
]);
export type ComplianceExclusionReason = z.infer<typeof ComplianceExclusionReasonSchema>;

export const TrainingStatusSchema = z.enum([
  "NOT_STARTED",
  "IN_PROGRESS",
  "SUBMITTED",
  "COMPLETED",
  "OVERDUE",
  "WAIVED"
]);
export type TrainingStatus = z.infer<typeof TrainingStatusSchema>;

export const TrainingSubmissionMethodSchema = z.enum([
  "MANUAL",
  "CERTIFICATE_LINK",
  "SELF_ATTESTED"
]);
export type TrainingSubmissionMethod = z.infer<typeof TrainingSubmissionMethodSchema>;

export const TrainingRecordSourceSchema = z.enum([
  "ADMIN",
  "SELF_SERVICE",
  "IMPORT",
  "PROVIDER"
]);
export type TrainingRecordSource = z.infer<typeof TrainingRecordSourceSchema>;

export const AccessReviewStatusSchema = z.enum([
  "PENDING",
  "IN_PROGRESS",
  "COMPLETED",
  "CANCELLED"
]);
export type AccessReviewStatus = z.infer<typeof AccessReviewStatusSchema>;

export const AccessReviewItemDecisionSchema = z.enum([
  "CERTIFY",
  "COMPENSATE",
  "ACCEPT_RISK",
  "REVOKE",
  "MODIFY",
  "NOT_APPLICABLE",
  "PENDING_DECISION"
]);
export type AccessReviewItemDecision = z.infer<typeof AccessReviewItemDecisionSchema>;

export const DeviceComplianceStatusSchema = z.enum([
  "COMPLIANT",
  "NON_COMPLIANT",
  "UNKNOWN",
  "PENDING_CHECK"
]);
export type DeviceComplianceStatus = z.infer<typeof DeviceComplianceStatusSchema>;

export const DeviceLifecycleStatusSchema = z.enum([
  "IN_STOCK",
  "ASSIGNED",
  "IN_TRANSIT",
  "IN_REPAIR",
  "RETIRED",
  "LOST"
]);
export type DeviceLifecycleStatus = z.infer<typeof DeviceLifecycleStatusSchema>;

export const DeviceSecurityCheckKeySchema = z.enum([
  "DISK_ENCRYPTION",
  "FIREWALL",
  "ANTIVIRUS",
  "AUTO_UPDATE",
  "PASSWORD_MANAGER"
]);
export type DeviceSecurityCheckKey = z.infer<typeof DeviceSecurityCheckKeySchema>;

export const DeviceSecurityCheckResultSchema = z.enum([
  "PASS",
  "FAIL"
]);
export type DeviceSecurityCheckResult = z.infer<typeof DeviceSecurityCheckResultSchema>;

export const DeviceSecurityCheckSourceSchema = z.enum([
  "MANUAL_SCREENSHOT"
]);
export type DeviceSecurityCheckSource = z.infer<typeof DeviceSecurityCheckSourceSchema>;

export const SystemInstanceFulfillmentSchema = z.enum([
  "API_INTEGRATED",
  "ATTESTED",
  "CHROME_CLONED",
  "MANUAL"
]);
export type SystemInstanceFulfillment = z.infer<typeof SystemInstanceFulfillmentSchema>;

export const PopulationTypeSchema = z.enum([
  "RISKS",
  "EMPLOYEES",
  "TERMINATED_EMPLOYEES",
  "NEW_HIRES",
  "CONTRACTORS",
  "USERS",
  "PRIVILEGED_USERS",
  "ASSETS",
  "VENDORS",
  "CHANGES",
  "INCIDENTS",
  "VISITORS",
  "DEVICES",
  "SERVERS",
  "REPOSITORIES",
  "TICKETS",
  "CUSTOM"
]);
export type PopulationType = z.infer<typeof PopulationTypeSchema>;

export const SamplingMethodSchema = z.enum([
  "RANDOM",
  "FIXED_COUNT",
  "FIXED_PERCENT",
  "STRATIFIED",
  "JUDGMENTAL",
  "ALL"
]);
export type SamplingMethod = z.infer<typeof SamplingMethodSchema>;

export const PopulationSourceTypeSchema = z.enum([
  "MANUAL_UPLOAD",
  "INTEGRATION_RESOURCE",
  "WORKSPACE_RECORD"
]);
export type PopulationSourceType = z.infer<typeof PopulationSourceTypeSchema>;

export const SampleItemStatusSchema = z.enum([
  "PENDING",
  "EVIDENCE_COLLECTED",
  "PASSED",
  "FAILED",
  "EXCEPTION"
]);
export type SampleItemStatus = z.infer<typeof SampleItemStatusSchema>;

export const DeviceDisposalReasonSchema = z.enum([
  "RETIRED",
  "REASSIGNED"
]);
export type DeviceDisposalReason = z.infer<typeof DeviceDisposalReasonSchema>;

export const DeviceDisposalMethodSchema = z.enum([
  "WIPED",
  "DESTROYED"
]);
export type DeviceDisposalMethod = z.infer<typeof DeviceDisposalMethodSchema>;

export const AttestationAnswerSchema = z.enum([
  "YES",
  "PARTIAL",
  "NO",
  "NA",
  "UNKNOWN"
]);
export type AttestationAnswer = z.infer<typeof AttestationAnswerSchema>;

export const ControlApplicabilitySchema = z.enum([
  "APPLICABLE",
  "NOT_APPLICABLE"
]);
export type ControlApplicability = z.infer<typeof ControlApplicabilitySchema>;

export const RequirementScopeSourceSchema = z.enum([
  "MANUAL",
  "AUTO_RULE"
]);
export type RequirementScopeSource = z.infer<typeof RequirementScopeSourceSchema>;

export const EvidenceSlotLifecycleSchema = z.enum([
  "ACTIVE",
  "RESERVED",
  "RETIRED"
]);
export type EvidenceSlotLifecycle = z.infer<typeof EvidenceSlotLifecycleSchema>;

export const EvidenceSlotOriginSchema = z.enum([
  "CANONICAL",
  "POLICY",
  "FALLBACK",
  "CUSTOM"
]);
export type EvidenceSlotOrigin = z.infer<typeof EvidenceSlotOriginSchema>;

export const SlotCitationOriginSchema = z.enum([
  "CANONICAL_CATALOG",
  "POLICY_CATALOG",
  "CONTROL_FALLBACK",
  "CUSTOM_USER"
]);
export type SlotCitationOrigin = z.infer<typeof SlotCitationOriginSchema>;

export const ControlLinkOriginSchema = z.enum([
  "SYSTEM_SLOT",
  "SYSTEM_CHECK",
  "SYSTEM_CITATION",
  "MANUAL",
  "LEGACY_UNKNOWN"
]);
export type ControlLinkOrigin = z.infer<typeof ControlLinkOriginSchema>;

export const ControlLinkStateSchema = z.enum([
  "LINKED",
  "EXCLUDED"
]);
export type ControlLinkState = z.infer<typeof ControlLinkStateSchema>;

export const CesCheckRoleSchema = z.enum([
  "REQUIRED",
  "SUPPORTING"
]);
export type CesCheckRole = z.infer<typeof CesCheckRoleSchema>;

export const CheckScheduleKindSchema = z.enum([
  "INTERVAL",
  "CRON"
]);
export type CheckScheduleKind = z.infer<typeof CheckScheduleKindSchema>;

export const ControlEvidenceStatusEnumSchema = z.enum([
  "NOT_STARTED",
  "IN_PROGRESS",
  "PASSED",
  "FAILED",
  "INCONCLUSIVE",
  "SUBMITTED",
  "NEEDS_RETEST",
  "APPROVED",
  "NOT_APPLICABLE",
  "NON_PERFORMING",
  "ON_HOLD",
  "BLOCKED"
]);
export type ControlEvidenceStatusEnum = z.infer<typeof ControlEvidenceStatusEnumSchema>;

export const ApiTestRunPhaseSchema = z.enum([
  "QUEUED",
  "RUNNING",
  "COMPLETED",
  "FAILED"
]);
export type ApiTestRunPhase = z.infer<typeof ApiTestRunPhaseSchema>;

export const ApiTestRunResultStatusSchema = z.enum([
  "PASS",
  "FAIL",
  "INCONCLUSIVE",
  "ERROR"
]);
export type ApiTestRunResultStatus = z.infer<typeof ApiTestRunResultStatusSchema>;

export const ImplementationStatusSchema = z.enum([
  "IMPLEMENTED",
  "UNIMPLEMENTED",
  "PARTIAL",
  "ERROR",
  "EXCEPTION"
]);
export type ImplementationStatus = z.infer<typeof ImplementationStatusSchema>;

export const ClaimDispositionSchema = z.enum([
  "LINK_EXISTING",
  "DISMISS"
]);
export type ClaimDisposition = z.infer<typeof ClaimDispositionSchema>;

export const QuestionnaireAnswerSourceSchema = z.enum([
  "MANUAL",
  "IMPORTED",
  "SCANNER",
  "LEGACY_CES"
]);
export type QuestionnaireAnswerSource = z.infer<typeof QuestionnaireAnswerSourceSchema>;

export const PolicyProjectionIntentStatusSchema = z.enum([
  "PENDING",
  "ENQUEUED",
  "APPLYING",
  "APPLIED",
  "FAILED"
]);
export type PolicyProjectionIntentStatus = z.infer<typeof PolicyProjectionIntentStatusSchema>;

export const PolicyCommitmentOriginSchema = z.enum([
  "BLUEPRINT",
  "IMPORT",
  "MANUAL"
]);
export type PolicyCommitmentOrigin = z.infer<typeof PolicyCommitmentOriginSchema>;

export const PolicyCommitmentOwnershipSchema = z.enum([
  "SYSTEM",
  "CUSTOMER"
]);
export type PolicyCommitmentOwnership = z.infer<typeof PolicyCommitmentOwnershipSchema>;

export const PolicyCommitmentStanceSchema = z.enum([
  "SATISFIED",
  "GAP",
  "COMPENSATED",
  "ACCEPTED_RISK"
]);
export type PolicyCommitmentStance = z.infer<typeof PolicyCommitmentStanceSchema>;

export const PolicyClaimRetirementReasonSchema = z.enum([
  "NO_LONGER_RENDERED",
  "BLUEPRINT_REMOVED",
  "POLICY_DELETED",
  "SUPERSEDED"
]);
export type PolicyClaimRetirementReason = z.infer<typeof PolicyClaimRetirementReasonSchema>;

export const ClaimSourceSchema = z.enum([
  "POLICY",
  "TSC_GAP"
]);
export type ClaimSource = z.infer<typeof ClaimSourceSchema>;

export const AssertionSourceSchema = z.enum([
  "AI",
  "HUMAN",
  "SYSTEM",
  "SCANNER"
]);
export type AssertionSource = z.infer<typeof AssertionSourceSchema>;

export const PolicySourceSchema = z.enum([
  "GENERATED",
  "IMPORTED",
  "IMPORTED_THEN_AI",
  "AI_THEN_EDITED"
]);
export type PolicySource = z.infer<typeof PolicySourceSchema>;

export const EvidenceFrequencySchema = z.enum([
  "ONCE",
  "MONTHLY",
  "QUARTERLY",
  "SEMI_ANNUAL",
  "ANNUAL"
]);
export type EvidenceFrequency = z.infer<typeof EvidenceFrequencySchema>;

export const SubtaskSourceSchema = z.enum([
  "SAMPLE_ITEM",
  "TEMPLATE_DEFINITION",
  "MANUAL"
]);
export type SubtaskSource = z.infer<typeof SubtaskSourceSchema>;

export const EvidenceReviewStatusSchema = z.enum([
  "PENDING",
  "APPROVED",
  "NEEDS_REVISION",
  "WITHDRAWN"
]);
export type EvidenceReviewStatus = z.infer<typeof EvidenceReviewStatusSchema>;

export const AuditorCommentTargetSchema = z.enum([
  "CONTROL",
  "TEST",
  "EVIDENCE_ITEM",
  "POLICY",
  "POLICY_SUBMISSION",
  "GENERAL"
]);
export type AuditorCommentTarget = z.infer<typeof AuditorCommentTargetSchema>;

export const AuditorCommentTypeSchema = z.enum([
  "NOTE",
  "EVIDENCE_REQUEST",
  "CLARIFICATION",
  "EXCEPTION"
]);
export type AuditorCommentType = z.infer<typeof AuditorCommentTypeSchema>;

export const AuditorReviewStatusSchema = z.enum([
  "REVIEWED",
  "SATISFACTORY",
  "EXCEPTION_NOTED",
  "NEEDS_REMEDIATION"
]);
export type AuditorReviewStatus = z.infer<typeof AuditorReviewStatusSchema>;

export const AuditorPolicySubmissionStatusSchema = z.enum([
  "SUBMITTED",
  "APPROVED",
  "NEEDS_REVISION",
  "SUPERSEDED"
]);
export type AuditorPolicySubmissionStatus = z.infer<typeof AuditorPolicySubmissionStatusSchema>;

export const TemplateTypeSchema = z.enum([
  "POLICY",
  "API",
  "CONTAINER",
  "REPORT"
]);
export type TemplateType = z.infer<typeof TemplateTypeSchema>;

export const EvidenceCategorySchema = z.enum([
  "POLICY",
  "PROCEDURE",
  "DESCRIPTION",
  "REGISTER",
  "RECORD",
  "CONFIGURATION"
]);
export type EvidenceCategory = z.infer<typeof EvidenceCategorySchema>;

export const AppTypeSchema = z.enum([
  "AWS",
  "AZURE",
  "GCP",
  "OKTA",
  "AUTH0",
  "ONELOGIN",
  "JUMPCLOUD",
  "GITHUB",
  "GITLAB",
  "BITBUCKET",
  "JIRA",
  "CONFLUENCE",
  "GOOGLE_WORKSPACE",
  "MICROSOFT_365",
  "SLACK",
  "NOTION",
  "ZOOM",
  "STRIPE",
  "QUICKBOOKS",
  "BREX",
  "SALESFORCE",
  "HUBSPOT",
  "DATADOG",
  "SPLUNK",
  "CROWDSTRIKE",
  "SNYK",
  "WORKDAY",
  "BAMBOOHR",
  "RIPPLING",
  "GUSTO",
  "OTHER"
]);
export type AppType = z.infer<typeof AppTypeSchema>;

export const PublisherTypeSchema = z.enum([
  "INDIVIDUAL",
  "ORGANIZATION"
]);
export type PublisherType = z.infer<typeof PublisherTypeSchema>;

export const LicenseTypeSchema = z.enum([
  "MIT",
  "CC_BY",
  "PROPRIETARY"
]);
export type LicenseType = z.infer<typeof LicenseTypeSchema>;

export const VerificationBadgeSchema = z.enum([
  "COMMUNITY",
  "PARTNER",
  "AUDITOR_VERIFIED",
  "OFFICIAL"
]);
export type VerificationBadge = z.infer<typeof VerificationBadgeSchema>;

export const ShareAccessTypeSchema = z.enum([
  "Public",
  "Private",
  "EmailDomains",
  "Password"
]);
export type ShareAccessType = z.infer<typeof ShareAccessTypeSchema>;

export const WorkspaceRoleSchema = z.enum([
  "ADMIN",
  "CONTRIBUTOR",
  "VIEWER",
  "AUDITOR",
  "EMPLOYEE"
]);
export type WorkspaceRole = z.infer<typeof WorkspaceRoleSchema>;

export const ReaderAccessTypeSchema = z.enum([
  "DIRECT",
  "DOMAIN",
  "PUBLIC",
  "INVITE",
  "SHARE_LINK"
]);
export type ReaderAccessType = z.infer<typeof ReaderAccessTypeSchema>;

export const SsoProviderStatusSchema = z.enum([
  "SETUP",
  "ACTIVE",
  "DISABLED"
]);
export type SsoProviderStatus = z.infer<typeof SsoProviderStatusSchema>;

export const StepStatusSchema = z.enum([
  "Recorded",
  "IntentAnalyzed",
  "Analyzed",
  "Ignored"
]);
export type StepStatus = z.infer<typeof StepStatusSchema>;

export const StepTypeSchema = z.enum([
  "RecordingControl",
  "Step",
  "Navigation"
]);
export type StepType = z.infer<typeof StepTypeSchema>;

export const ActionTypeSchema = z.enum([
  "Click",
  "RightClick",
  "Hover",
  "Input",
  "Type",
  "Submit",
  "Scroll",
  "Navigation",
  "Highlight",
  "Screenshot",
  "StartRecording",
  "StopRecording",
  "PauseRecording",
  "ResumeRecording",
  "Unknown"
]);
export type ActionType = z.infer<typeof ActionTypeSchema>;

export const SourceTypeSchema = z.enum([
  "Doc",
  "Website",
  "File",
  "Flow",
  "Screenshot",
  "UserUploadedFile",
  "Code",
  "GitHubPullRequest",
  "GitHubIssue",
  "GitHubCode",
  "CodeRepository",
  "CodeFile",
  "SlackMessage",
  "SlackThread",
  "TeamsMessage",
  "TeamsThread",
  "Integration",
  "ExternalDocs",
  "ChatMessage",
  "GoogleDriveFile",
  "GoogleDriveDoc",
  "GoogleDriveSheet",
  "GoogleDriveSlides",
  "NotionPage",
  "NotionDatabase",
  "ConfluencePage",
  "ConfluenceSpace",
  "ConfluenceBlogPost",
  "ConfluenceAttachment",
  "ZendeskTicket",
  "IntercomConversation",
  "AsanaTask",
  "ShortcutStory",
  "TrelloCard",
  "WrikeTask",
  "ClickUpTask",
  "ServiceNowTask",
  "SalesforceCase",
  "MondayItem",
  "LinearIssue",
  "JiraTicket",
  "FreshdeskTicket",
  "ANALYZER_STRUCTURE",
  "ANALYZER_DATA_FLOW",
  "ANALYZER_DEPENDENCY",
  "ANALYZER_REQUEST_FLOW",
  "ANALYZER_API",
  "TECHNICAL_DOCUMENTATION",
  "EvidenceFile",
  "COMPLIANCE_ANALYSIS",
  "PolicyDocument",
  "VaultDocument"
]);
export type SourceType = z.infer<typeof SourceTypeSchema>;

export const SourceStatusSchema = z.enum([
  "Pending",
  "Success",
  "Failed",
  "Indexing",
  "Extracting",
  "Summarizing",
  "Disabled"
]);
export type SourceStatus = z.infer<typeof SourceStatusSchema>;

export const IntegrationTypeSchema = z.enum([
  "GitHub",
  "GitLab",
  "Bitbucket",
  "Jira",
  "Confluence",
  "GoogleDrive",
  "Dropbox",
  "OneDrive",
  "Docusaurus",
  "VitePress",
  "Vanta",
  "Drata",
  "SecureFrame",
  "FieldGuide",
  "GitBook",
  "LocalFile",
  "Slack",
  "MicrosoftTeams",
  "MicrosoftTeamsBot",
  "Notion",
  "Asana",
  "ClickUp",
  "Shortcut",
  "Trello",
  "Wrike",
  "Linear",
  "Zendesk",
  "Freshdesk",
  "Intercom",
  "GitHubIssues",
  "Other",
  "AWS_READONLY",
  "GCP_READONLY",
  "AZURE_READONLY",
  "AZURE_DEVOPS",
  "MicrosoftIntune",
  "FleetDM",
  "JamfPro",
  "Okta",
  "GoogleWorkspace",
  "OnePassword",
  "Tailscale",
  "Auth0",
  "OneLogin",
  "JumpCloud",
  "Datadog",
  "Axiom",
  "CrowdStrike",
  "Snyk",
  "Aikido",
  "Zoom",
  "Stripe",
  "QuickBooks",
  "Sentry",
  "PagerDuty",
  "IncidentIo",
  "ServiceNow",
  "Box",
  "Kandji",
  "KnowBe4",
  "Vercel",
  "Render",
  "Brex",
  "Salesforce",
  "Monday",
  "Snowflake",
  "HubSpot",
  "Workday",
  "SuccessFactors",
  "BambooHR",
  "HiBob",
  "ADP",
  "Rippling",
  "Deel",
  "Gusto",
  "M365",
  "Kubernetes",
  "OpenAttest",
  "Jamf",
  "Checkr",
  "Wiz",
  "Orca",
  "AWS_SECURITY_HUB",
  "GCP_SECURITY_COMMAND_CENTER",
  "AZURE_DEFENDER",
  "GITHUB_SECURITY_ALERTS",
  "Cloudflare",
  "Aliyun",
  "TencentCloud",
  "MicrosoftSharePoint",
  "Supabase"
]);
export type IntegrationType = z.infer<typeof IntegrationTypeSchema>;

export const MountTypeSchema = z.enum([
  "GITHUB",
  "NOTION",
  "GOOGLE_DOCS",
  "CONFLUENCE"
]);
export type MountType = z.infer<typeof MountTypeSchema>;

export const ScreenshotScopeSchema = z.enum([
  "VIEWPORT",
  "FULL_PAGE",
  "SCREEN"
]);
export type ScreenshotScope = z.infer<typeof ScreenshotScopeSchema>;

export const HtmlSnapshotTypeSchema = z.enum([
  "Full",
  "Incremental"
]);
export type HtmlSnapshotType = z.infer<typeof HtmlSnapshotTypeSchema>;

export const ActionConnectionTypeSchema = z.enum([
  "Primary",
  "Alternative",
  "Back"
]);
export type ActionConnectionType = z.infer<typeof ActionConnectionTypeSchema>;

export const IntegrationCategorySchema = z.enum([
  "Ticketing",
  "KnowledgeBase",
  "Communication",
  "DocumentationExport",
  "MDM",
  "IdentityProvider",
  "SecurityMonitoring",
  "Other"
]);
export type IntegrationCategory = z.infer<typeof IntegrationCategorySchema>;

export const IntegrationAccessLevelSchema = z.enum([
  "read_only",
  "read_write"
]);
export type IntegrationAccessLevel = z.infer<typeof IntegrationAccessLevelSchema>;

export const ConnectionTypeSchema = z.enum([
  "IMPORT",
  "EXPORT",
  "NOTIFICATION",
  "COMPLIANCE_UPLOAD"
]);
export type ConnectionType = z.infer<typeof ConnectionTypeSchema>;

export const ConnectionStatusSchema = z.enum([
  "PENDING",
  "ACTIVE",
  "PAUSED",
  "ERROR",
  "SYNCING"
]);
export type ConnectionStatus = z.infer<typeof ConnectionStatusSchema>;

export const SyncOperationSchema = z.enum([
  "IMPORT",
  "EXPORT",
  "TEST",
  "VALIDATE"
]);
export type SyncOperation = z.infer<typeof SyncOperationSchema>;

export const SyncStatusSchema = z.enum([
  "SUCCESS",
  "PARTIAL",
  "FAILED",
  "CANCELLED"
]);
export type SyncStatus = z.infer<typeof SyncStatusSchema>;

export const MediaTypeSchema = z.enum([
  "VIDEO",
  "AUDIO"
]);
export type MediaType = z.infer<typeof MediaTypeSchema>;

export const VideoTypeSchema = z.enum([
  "SCREEN_RECORDING",
  "IMPORTED"
]);
export type VideoType = z.infer<typeof VideoTypeSchema>;

export const FeedbackSourceSchema = z.enum([
  "USER",
  "AI",
  "CODE",
  "PRD",
  "AUTOMATIC_CHECK",
  "REPLAY_AI_ANALYSIS",
  "INTEGRATION"
]);
export type FeedbackSource = z.infer<typeof FeedbackSourceSchema>;

export const FeedbackTypeSchema = z.enum([
  "REACTION",
  "COMMENT",
  "ACTIVITY",
  "GAP",
  "KNOWLEDGE_GAP",
  "UPDATE_SUGGESTION"
]);
export type FeedbackType = z.infer<typeof FeedbackTypeSchema>;

export const FeedbackStatusSchema = z.enum([
  "OPEN",
  "IN_PROGRESS",
  "RESOLVED",
  "SNOOZED",
  "IGNORED",
  "DOC_NEEDS_UPDATE"
]);
export type FeedbackStatus = z.infer<typeof FeedbackStatusSchema>;

export const TaskStatusSchema = z.enum([
  "OPEN",
  "ASSIGNED",
  "IN_PROGRESS",
  "IN_REVIEW",
  "BLOCKED",
  "RESOLVED",
  "DISMISSED"
]);
export type TaskStatus = z.infer<typeof TaskStatusSchema>;

export const PrioritySchema = z.enum([
  "LOW",
  "MEDIUM",
  "HIGH"
]);
export type Priority = z.infer<typeof PrioritySchema>;

export const TaskSourceSchema = z.enum([
  "MANUAL",
  "EMAIL",
  "SLACK",
  "TEAMS",
  "AGENT",
  "SCAN",
  "API",
  "WEBHOOK"
]);
export type TaskSource = z.infer<typeof TaskSourceSchema>;

export const CommentStatusSchema = z.enum([
  "OPEN",
  "IN_PROGRESS",
  "RESOLVED",
  "DISMISSED",
  "IMPLEMENTED"
]);
export type CommentStatus = z.infer<typeof CommentStatusSchema>;

export const CommentVisibilitySchema = z.enum([
  "PRIVATE",
  "WORKSPACE",
  "PUBLIC"
]);
export type CommentVisibility = z.infer<typeof CommentVisibilitySchema>;

export const CommentScopeSchema = z.enum([
  "PAGE",
  "BLOCK",
  "RANGE",
  "WORKSPACE"
]);
export type CommentScope = z.infer<typeof CommentScopeSchema>;

export const CommentTypeSchema = z.enum([
  "COMMENT",
  "REPLY"
]);
export type CommentType = z.infer<typeof CommentTypeSchema>;

export const AgentChoiceStatusSchema = z.enum([
  "PENDING",
  "RESOLVED",
  "SUPERSEDED",
  "EXPIRED"
]);
export type AgentChoiceStatus = z.infer<typeof AgentChoiceStatusSchema>;

export const AgentChoiceContinuationStatusSchema = z.enum([
  "PENDING",
  "PROCESSING",
  "COMPLETED",
  "FAILED"
]);
export type AgentChoiceContinuationStatus = z.infer<typeof AgentChoiceContinuationStatusSchema>;

export const GitSyncStatusSchema = z.enum([
  "SYNCED",
  "PENDING",
  "CONFLICT",
  "ERROR",
  "PUBLISHING"
]);
export type GitSyncStatus = z.infer<typeof GitSyncStatusSchema>;

export const GitOperationTypeSchema = z.enum([
  "PUSH",
  "PULL",
  "FETCH",
  "MERGE",
  "COMMIT",
  "CREATE_BRANCH",
  "SWITCH_BRANCH",
  "CREATE_TAG",
  "CREATE_PR",
  "MERGE_ABORT",
  "INIT_REPOSITORY",
  "CLONE_REPOSITORY",
  "DELETE_BRANCH"
]);
export type GitOperationType = z.infer<typeof GitOperationTypeSchema>;

export const GitOperationStatusSchema = z.enum([
  "SUCCESS",
  "FAILURE",
  "CONFLICT",
  "PENDING"
]);
export type GitOperationStatus = z.infer<typeof GitOperationStatusSchema>;

export const PropertyTypeSchema = z.enum([
  "TEXT",
  "LONGTEXT",
  "NUMBER",
  "SELECT",
  "MULTISELECT",
  "DATE",
  "DATETIME",
  "BOOLEAN",
  "URL",
  "EMAIL",
  "USER",
  "STATUS"
]);
export type PropertyType = z.infer<typeof PropertyTypeSchema>;

export const ChangeRequestStatusSchema = z.enum([
  "DRAFT",
  "IN_REVIEW",
  "APPROVED",
  "MERGED",
  "CLOSED"
]);
export type ChangeRequestStatus = z.infer<typeof ChangeRequestStatusSchema>;

export const ReviewStatusSchema = z.enum([
  "APPROVED",
  "CHANGES_REQUESTED",
  "COMMENT"
]);
export type ReviewStatus = z.infer<typeof ReviewStatusSchema>;

export const ReplayChatStatusSchema = z.enum([
  "ACTIVE",
  "RESOLVED",
  "ARCHIVED"
]);
export type ReplayChatStatus = z.infer<typeof ReplayChatStatusSchema>;

export const MessageRoleSchema = z.enum([
  "USER",
  "ASSISTANT",
  "SYSTEM"
]);
export type MessageRole = z.infer<typeof MessageRoleSchema>;

export const ChunkUploadStatusSchema = z.enum([
  "PENDING",
  "UPLOADING",
  "COMPLETED",
  "FAILED"
]);
export type ChunkUploadStatus = z.infer<typeof ChunkUploadStatusSchema>;

export const ChunkTranscriptStatusSchema = z.enum([
  "PENDING",
  "TRANSCRIBING",
  "COMPLETED",
  "FAILED"
]);
export type ChunkTranscriptStatus = z.infer<typeof ChunkTranscriptStatusSchema>;

export const ReplaySessionModeSchema = z.enum([
  "edit",
  "guide"
]);
export type ReplaySessionMode = z.infer<typeof ReplaySessionModeSchema>;

export const ReplaySessionStatusSchema = z.enum([
  "IN_PROGRESS",
  "COMPLETED",
  "FAILED"
]);
export type ReplaySessionStatus = z.infer<typeof ReplaySessionStatusSchema>;

export const RenderStatusSchema = z.enum([
  "PENDING",
  "PROCESSING",
  "COMPLETED",
  "FAILED"
]);
export type RenderStatus = z.infer<typeof RenderStatusSchema>;

export const AssetTypeSchema = z.enum([
  "IMAGE",
  "VIDEO",
  "AUDIO",
  "FONT"
]);
export type AssetType = z.infer<typeof AssetTypeSchema>;

export const GapStatusSchema = z.enum([
  "IDENTIFIED",
  "IN_PROGRESS",
  "DOC_NEEDS_UPDATE",
  "RESOLVED",
  "IGNORED",
  "OUTDATED"
]);
export type GapStatus = z.infer<typeof GapStatusSchema>;

export const GapPrioritySchema = z.enum([
  "CRITICAL",
  "HIGH",
  "MEDIUM",
  "LOW"
]);
export type GapPriority = z.infer<typeof GapPrioritySchema>;

export const PlanSchema = z.enum([
  "FREE",
  "STARTER",
  "TEAM",
  "PRO",
  "ENTERPRISE",
  "CUSTOM"
]);
export type Plan = z.infer<typeof PlanSchema>;

export const ProductSchema = z.enum([
  "DEEPGUIDE",
  "SCREENATA"
]);
export type Product = z.infer<typeof ProductSchema>;

export const SubscriptionStatusSchema = z.enum([
  "ACTIVE",
  "TRIALING",
  "PAST_DUE",
  "CANCELED",
  "INCOMPLETE",
  "PAUSED"
]);
export type SubscriptionStatus = z.infer<typeof SubscriptionStatusSchema>;

export const ComplianceFrameworkSchema = z.enum([
  "SOC2",
  "CMMC",
  "ISO27001",
  "ISO42001",
  "GDPR",
  "HIPAA",
  "HITRUST",
  "FEDRAMP",
  "NIST_800_53",
  "NIST_800_171",
  "PCI_DSS"
]);
export type ComplianceFramework = z.infer<typeof ComplianceFrameworkSchema>;

export const WorkspaceTypeSchema = z.enum([
  "DOCUMENTATION",
  "COMPLIANCE",
  "TRAINING",
  "SUPPORT",
  "API_DOCS",
  "RUNBOOKS",
  "SCREENATA"
]);
export type WorkspaceType = z.infer<typeof WorkspaceTypeSchema>;

export const WorkspaceFeatureSchema = z.enum([
  "COMPLIANCE_AUTOMATION",
  "API_DOCUMENTATION",
  "VIDEO_TUTORIALS",
  "KNOWLEDGE_BASE",
  "CHANGE_MANAGEMENT",
  "WORKFLOW_AUTOMATION"
]);
export type WorkspaceFeature = z.infer<typeof WorkspaceFeatureSchema>;

export const FlagCategorySchema = z.enum([
  "FEATURE",
  "EXPERIMENT",
  "OPERATIONAL",
  "PERMISSION"
]);
export type FlagCategory = z.infer<typeof FlagCategorySchema>;

export const EnvironmentSchema = z.enum([
  "DEVELOPMENT",
  "STAGING",
  "PRODUCTION"
]);
export type Environment = z.infer<typeof EnvironmentSchema>;

export const AuditActionSchema = z.enum([
  "CREATE",
  "UPDATE",
  "DELETE",
  "OVERRIDE",
  "ROLLBACK"
]);
export type AuditAction = z.infer<typeof AuditActionSchema>;

export const PurchaseStatusSchema = z.enum([
  "PENDING",
  "COMPLETED",
  "FAILED",
  "REFUNDED"
]);
export type PurchaseStatus = z.infer<typeof PurchaseStatusSchema>;

export const SeatChangeTypeSchema = z.enum([
  "ADDITION",
  "REMOVAL",
  "ADJUSTMENT"
]);
export type SeatChangeType = z.infer<typeof SeatChangeTypeSchema>;

export const TrialEventTypeSchema = z.enum([
  "TRIAL_STARTED",
  "TRIAL_REMINDER_SENT",
  "TRIAL_EXTENDED",
  "TRIAL_CONVERTED",
  "TRIAL_EXPIRED",
  "TRIAL_DOWNGRADED"
]);
export type TrialEventType = z.infer<typeof TrialEventTypeSchema>;

export const GitHubBranchProtectionModeSchema = z.enum([
  "CLASSIC",
  "RULESET"
]);
export type GitHubBranchProtectionMode = z.infer<typeof GitHubBranchProtectionModeSchema>;

export const ActorTypeSchema = z.enum([
  "ADMIN",
  "USER",
  "SYSTEM"
]);
export type ActorType = z.infer<typeof ActorTypeSchema>;

export const ActionResultSchema = z.enum([
  "SUCCESS",
  "FAILURE"
]);
export type ActionResult = z.infer<typeof ActionResultSchema>;

export const SecuritySeveritySchema = z.enum([
  "LOW",
  "MEDIUM",
  "HIGH",
  "CRITICAL"
]);
export type SecuritySeverity = z.infer<typeof SecuritySeveritySchema>;

export const SecurityEventTypeSchema = z.enum([
  "BRUTE_FORCE",
  "UNUSUAL_ACCESS",
  "DATA_EXPORT",
  "API_ABUSE",
  "RATE_LIMIT"
]);
export type SecurityEventType = z.infer<typeof SecurityEventTypeSchema>;

export const SecurityEventStatusSchema = z.enum([
  "OPEN",
  "INVESTIGATING",
  "RESOLVED",
  "FALSE_POSITIVE"
]);
export type SecurityEventStatus = z.infer<typeof SecurityEventStatusSchema>;

export const ImpersonationScopeSchema = z.enum([
  "READ",
  "FULL"
]);
export type ImpersonationScope = z.infer<typeof ImpersonationScopeSchema>;

export const AnnouncementSeveritySchema = z.enum([
  "INFO",
  "WARNING",
  "CRITICAL"
]);
export type AnnouncementSeverity = z.infer<typeof AnnouncementSeveritySchema>;

export const AnnouncementTargetSchema = z.enum([
  "ALL",
  "PLAN",
  "ORGANIZATION"
]);
export type AnnouncementTarget = z.infer<typeof AnnouncementTargetSchema>;

export const DomainVerificationStatusSchema = z.enum([
  "PENDING",
  "VERIFIED",
  "FAILED"
]);
export type DomainVerificationStatus = z.infer<typeof DomainVerificationStatusSchema>;

export const DomainSSLStatusSchema = z.enum([
  "PENDING",
  "ACTIVE",
  "EXPIRED",
  "FAILED"
]);
export type DomainSSLStatus = z.infer<typeof DomainSSLStatusSchema>;

export const WorkflowExecutionFailedTypeSchema = z.enum([
  "LOGIN_EXPIRED",
  "VALIDATION_FAILED",
  "SELECTOR_FAILED",
  "UNKNOWN"
]);
export type WorkflowExecutionFailedType = z.infer<typeof WorkflowExecutionFailedTypeSchema>;

export const RunbookKindSchema = z.enum([
  "AUTOMATION",
  "PROCEDURE",
  "MIXED"
]);
export type RunbookKind = z.infer<typeof RunbookKindSchema>;

export const RunbookCategorySchema = z.enum([
  "screenshot",
  "attestation",
  "guided",
  "automation",
  "mixed"
]);
export type RunbookCategory = z.infer<typeof RunbookCategorySchema>;

export const StepKindSchema = z.enum([
  "automated",
  "review",
  "upload",
  "attest",
  "assisted",
  "notify",
  "human"
]);
export type StepKind = z.infer<typeof StepKindSchema>;

export const AutomatedRunnerSchema = z.enum([
  "api",
  "tool",
  "browser"
]);
export type AutomatedRunner = z.infer<typeof AutomatedRunnerSchema>;

export const WorkflowRunStatusSchema = z.enum([
  "RUNNING",
  "COMPLETED",
  "FAILED",
  "PARTIAL",
  "AWAITING_HUMAN",
  "CANCELLED"
]);
export type WorkflowRunStatus = z.infer<typeof WorkflowRunStatusSchema>;

export const StepRunStatusSchema = z.enum([
  "PENDING",
  "RUNNING",
  "AWAITING_HUMAN",
  "COMPLETED",
  "FAILED",
  "SKIPPED"
]);
export type StepRunStatus = z.infer<typeof StepRunStatusSchema>;

export const ApprovalStatusSchema = z.enum([
  "PENDING",
  "APPROVED",
  "REJECTED",
  "NEEDS_REVIEW"
]);
export type ApprovalStatus = z.infer<typeof ApprovalStatusSchema>;

export const BugReportStatusSchema = z.enum([
  "OPEN",
  "IN_PROGRESS",
  "RESOLVED",
  "CLOSED",
  "WONT_FIX"
]);
export type BugReportStatus = z.infer<typeof BugReportStatusSchema>;

export const BugReportPrioritySchema = z.enum([
  "LOW",
  "MEDIUM",
  "HIGH",
  "CRITICAL"
]);
export type BugReportPriority = z.infer<typeof BugReportPrioritySchema>;

export const RiskTypeSchema = z.enum([
  "OPERATIONAL",
  "FRAUD",
  "VULNERABILITY"
]);
export type RiskType = z.infer<typeof RiskTypeSchema>;

export const RiskRatingSchema = z.enum([
  "LOW",
  "MEDIUM",
  "HIGH",
  "CRITICAL"
]);
export type RiskRating = z.infer<typeof RiskRatingSchema>;

export const RiskLikelihoodSchema = z.enum([
  "VERY_LOW",
  "LOW",
  "MEDIUM",
  "HIGH",
  "VERY_HIGH"
]);
export type RiskLikelihood = z.infer<typeof RiskLikelihoodSchema>;

export const RiskImpactSchema = z.enum([
  "VERY_LOW",
  "LOW",
  "MEDIUM",
  "HIGH",
  "VERY_HIGH"
]);
export type RiskImpact = z.infer<typeof RiskImpactSchema>;

export const RiskStatusSchema = z.enum([
  "OPEN",
  "ASSESSING",
  "PENDING_REVIEW",
  "IN_PROGRESS",
  "CLOSED",
  "MONITORING"
]);
export type RiskStatus = z.infer<typeof RiskStatusSchema>;

export const RiskTreatmentSchema = z.enum([
  "MITIGATE",
  "ACCEPT",
  "TRANSFER",
  "AVOID"
]);
export type RiskTreatment = z.infer<typeof RiskTreatmentSchema>;

export const RiskSnapshotTriggerSchema = z.enum([
  "MANUAL",
  "SCHEDULED",
  "ASSESSMENT_PUBLISHED",
  "REPORT"
]);
export type RiskSnapshotTrigger = z.infer<typeof RiskSnapshotTriggerSchema>;

export const RiskReportCadenceSchema = z.enum([
  "QUARTERLY",
  "ANNUAL",
  "CUSTOM_CRON"
]);
export type RiskReportCadence = z.infer<typeof RiskReportCadenceSchema>;

export const RiskSourceTypeSchema = z.enum([
  "ZAP",
  "GITHUB_SCAN",
  "SNYK",
  "PENTEST",
  "MANUAL",
  "DEPENDENCY_SCAN",
  "CONFIG_REVIEW",
  "SCAN_FINDING",
  "GAP_ANALYSIS",
  "POSTURE_ATTESTATION",
  "OTHER"
]);
export type RiskSourceType = z.infer<typeof RiskSourceTypeSchema>;

export const RiskSyncStatusSchema = z.enum([
  "SYNCED",
  "STALE",
  "ARCHIVED"
]);
export type RiskSyncStatus = z.infer<typeof RiskSyncStatusSchema>;

export const VendorCategorySchema = z.enum([
  "CLOUD_INFRASTRUCTURE",
  "IDENTITY",
  "DATABASE",
  "MONITORING",
  "CI_CD",
  "COMMUNICATION",
  "AI",
  "HR",
  "SECURITY",
  "OTHER"
]);
export type VendorCategory = z.infer<typeof VendorCategorySchema>;

export const VendorRiskTierSchema = z.enum([
  "CRITICAL",
  "HIGH",
  "MEDIUM",
  "LOW"
]);
export type VendorRiskTier = z.infer<typeof VendorRiskTierSchema>;

export const VendorRiskLevelSchema = z.enum([
  "VERY_LOW",
  "LOW",
  "MEDIUM",
  "HIGH",
  "VERY_HIGH"
]);
export type VendorRiskLevel = z.infer<typeof VendorRiskLevelSchema>;

export const VendorTierSourceSchema = z.enum([
  "CATEGORY_DEFAULT",
  "AI_SUGGESTED",
  "MANUAL"
]);
export type VendorTierSource = z.infer<typeof VendorTierSourceSchema>;

export const VendorBusinessCriticalitySchema = z.enum([
  "LOW",
  "MEDIUM",
  "HIGH"
]);
export type VendorBusinessCriticality = z.infer<typeof VendorBusinessCriticalitySchema>;

export const VendorStatusSchema = z.enum([
  "ACTIVE",
  "UNDER_REVIEW",
  "OFFBOARDED",
  "PENDING_ONBOARDING"
]);
export type VendorStatus = z.infer<typeof VendorStatusSchema>;

export const BAAStatusSchema = z.enum([
  "NOT_REQUIRED",
  "REQUIRED",
  "SIGNED",
  "EXPIRED"
]);
export type BAAStatus = z.infer<typeof BAAStatusSchema>;

export const VendorAuthenticationMethodSchema = z.enum([
  "CREDENTIALS",
  "CREDENTIALS_WITH_MFA",
  "SSO",
  "NOT_APPLICABLE"
]);
export type VendorAuthenticationMethod = z.infer<typeof VendorAuthenticationMethodSchema>;

export const VendorEnvironmentAccessSchema = z.enum([
  "NO_ACCESS",
  "READ_ONLY",
  "READ_AND_WRITE"
]);
export type VendorEnvironmentAccess = z.infer<typeof VendorEnvironmentAccessSchema>;

export const VendorAssessmentStatusSchema = z.enum([
  "DRAFT",
  "SUBMITTED",
  "APPROVED",
  "REJECTED",
  "NEEDS_REVISION"
]);
export type VendorAssessmentStatus = z.infer<typeof VendorAssessmentStatusSchema>;

export const VendorControlCoverageSchema = z.enum([
  "SATISFIED",
  "PARTIAL",
  "NOT_COVERED"
]);
export type VendorControlCoverage = z.infer<typeof VendorControlCoverageSchema>;

export const VendorEvidenceRequestStatusSchema = z.enum([
  "OUTSTANDING",
  "RECEIVED",
  "WAIVED"
]);
export type VendorEvidenceRequestStatus = z.infer<typeof VendorEvidenceRequestStatusSchema>;

export const VendorAssessmentInputKindSchema = z.enum([
  "DOCUMENT",
  "RISK_FEED",
  "TRUST_CENTER",
  "CARRY_FORWARD"
]);
export type VendorAssessmentInputKind = z.infer<typeof VendorAssessmentInputKindSchema>;

export const VaultDocumentCategorySchema = z.enum([
  "POLICY",
  "PROCEDURE",
  "TEMPLATE",
  "RECORD",
  "TRAINING",
  "REFERENCE",
  "CERTIFICATE",
  "OTHER"
]);
export type VaultDocumentCategory = z.infer<typeof VaultDocumentCategorySchema>;

export const VaultDocumentSourceSchema = z.enum([
  "AGENT_GENERATED",
  "MANUAL",
  "UPLOADED"
]);
export type VaultDocumentSource = z.infer<typeof VaultDocumentSourceSchema>;

export const VaultDocumentStatusSchema = z.enum([
  "ACTIVE",
  "ARCHIVED"
]);
export type VaultDocumentStatus = z.infer<typeof VaultDocumentStatusSchema>;

export const SecurityQuestionnaireStatusSchema = z.enum([
  "UPLOADED",
  "PARSING",
  "PARSED",
  "DRAFTING",
  "IN_REVIEW",
  "COMPLETED",
  "FAILED"
]);
export type SecurityQuestionnaireStatus = z.infer<typeof SecurityQuestionnaireStatusSchema>;

export const QuestionnaireAnswerStatusSchema = z.enum([
  "PENDING",
  "DRAFTED",
  "APPROVED",
  "SKIPPED",
  "NEEDS_INFO",
  "REMOVED"
]);
export type QuestionnaireAnswerStatus = z.infer<typeof QuestionnaireAnswerStatusSchema>;

export const SecurityQuestionnaireSourceSchema = z.enum([
  "UPLOAD",
  "EXTENSION"
]);
export type SecurityQuestionnaireSource = z.infer<typeof SecurityQuestionnaireSourceSchema>;

export const InventoryAssetTypeSchema = z.enum([
  "COMPUTE",
  "STORAGE",
  "DATABASE",
  "NETWORK",
  "IDENTITY",
  "SAAS",
  "CONTAINER",
  "REPOSITORY",
  "DEVICE",
  "FACILITY",
  "DATASET",
  "APPLICATION",
  "AI_SYSTEM",
  "MODEL",
  "MCP_SERVER",
  "PROMPT",
  "AGENT",
  "TOOL",
  "GUARDRAIL",
  "OTHER"
]);
export type InventoryAssetType = z.infer<typeof InventoryAssetTypeSchema>;

export const AssetCriticalitySchema = z.enum([
  "CRITICAL",
  "HIGH",
  "MEDIUM",
  "LOW"
]);
export type AssetCriticality = z.infer<typeof AssetCriticalitySchema>;

export const DataClassificationSchema = z.enum([
  "PUBLIC",
  "INTERNAL",
  "CONFIDENTIAL",
  "RESTRICTED"
]);
export type DataClassification = z.infer<typeof DataClassificationSchema>;

export const AssetStatusSchema = z.enum([
  "ACTIVE",
  "INACTIVE",
  "DECOMMISSIONED",
  "UNKNOWN"
]);
export type AssetStatus = z.infer<typeof AssetStatusSchema>;

export const AssetSyncStatusSchema = z.enum([
  "SYNCED",
  "DRIFTED",
  "ORPHANED",
  "ERROR"
]);
export type AssetSyncStatus = z.infer<typeof AssetSyncStatusSchema>;

export const AiDeploymentStageSchema = z.enum([
  "EXPLORATORY",
  "DEVELOPMENT",
  "PILOT",
  "PRODUCTION",
  "RETIRED"
]);
export type AiDeploymentStage = z.infer<typeof AiDeploymentStageSchema>;

export const RemediationExecutionStatusSchema = z.enum([
  "pending_approval",
  "approved",
  "pending_execution",
  "succeeded",
  "failed",
  "partially_applied",
  "rejected"
]);
export type RemediationExecutionStatus = z.infer<typeof RemediationExecutionStatusSchema>;

export const RiskLinkTypeSchema = z.enum([
  "MITIGATES",
  "COMPENSATES",
  "DETECTS"
]);
export type RiskLinkType = z.infer<typeof RiskLinkTypeSchema>;

export const RiskAcceptanceStatusSchema = z.enum([
  "PENDING",
  "ACTIVE",
  "EXPIRED",
  "REVOKED"
]);
export type RiskAcceptanceStatus = z.infer<typeof RiskAcceptanceStatusSchema>;

export const SourceScanOriginSchema = z.enum([
  "CLI",
  "GITHUB_APP"
]);
export type SourceScanOrigin = z.infer<typeof SourceScanOriginSchema>;

export const EmailThreadMessageRoleSchema = z.enum([
  "user",
  "assistant"
]);
export type EmailThreadMessageRole = z.infer<typeof EmailThreadMessageRoleSchema>;

export const BackgroundCheckReportStatusSchema = z.enum([
  "NOT_REQUIRED",
  "COMPLETED",
  "PENDING",
  "CLEAR",
  "CONSIDER",
  "SUSPENDED",
  "DISPUTE",
  "CANCELED",
  "UNKNOWN"
]);
export type BackgroundCheckReportStatus = z.infer<typeof BackgroundCheckReportStatusSchema>;

export const AnonymousReportStatusSchema = z.enum([
  "OPEN",
  "IN_PROGRESS",
  "RESOLVED"
]);
export type AnonymousReportStatus = z.infer<typeof AnonymousReportStatusSchema>;

